<template>
  <Layout class="map-wrapper">
    <Header>
      <Row type="flex" justify="space-between">
        <Col>
          <Button type="text" size="large" @click="back">
            <Icon type="ios-arrow-back" />返回
          </Button>
        </Col>
        <Col class="text-center" :xs="11" :sm="8" :md="8">位置信息</Col>
        <Col>
          <a href="javascript: location.reload()" class="navbar-icon-btn-right">
            <img class="vm" src="@/assets/images/refresh.png" width="28" />
          </a>
        </Col>
      </Row>
    </Header>
    <baidu-map class="map-wrapper" :style="height" :center="center" :zoom="zoom" @ready="mapReady">
      <!-- 工程师位置标记 -->
      <bm-marker :position="engineer.position" :icon="engineer.icon" :offset="engineer.offset">
        <bm-label
          :content="engineerTitle"
          :labelStyle="labelStyle"
          :offset="{width: -30, height: 45}"
        />
      </bm-marker>
      <!-- 客户位置标记 -->
      <bm-marker :position="customer.position" :icon="customer.icon" :offset="customer.offset">
        <bm-label
          :content="customer.title"
          :labelStyle="labelStyle"
          :offset="{width: -20, height: 45}"
        />
      </bm-marker>
      <!-- 公交路线规划 -->
      <!-- <bm-transit @searchcomplete="searchcomplete" :start="engineer.position" :end="customer.position" :auto-viewport="true"
      :selectFirstResult="true"></bm-transit>-->
      <!-- 步行路线规划 -->
      <!-- <bm-walking @searchcomplete="searchcomplete" :start="engineer.position" :end="customer.position" :auto-viewport="true"
      :selectFirstResult="true"></bm-walking>-->
      <!-- 遮罩层 -->
      <Spin size="large" fix v-if="loading"></Spin>
    </baidu-map>
  </Layout>
</template>

<script>
import { getToken } from '@/assets/js/Util'

import jsonp from 'jsonp'

export default {
  data() {
    return {
      center: { lng: 0, lat: 0 },
      zoom: 3,
      loading: true,
      labelStyle: {
        borderColor: '#0076CE',
        color: '#0076CE',
        padding: '3px 8px',
        fontSize: '16px'
      },
      distance: '', // 距离
      duration: '',
      engineer: {
        position: {
          lat: 0,
          lng: 0
        },
        icon: {
          url: require('@/assets/images/engineer.png'),
          size: {
            width: 40,
            height: 40
          }
        },
        offset: {
          width: 0,
          height: -15
        },
        title: '工程师位置',
        address: '',
        showInfo: false
      },
      customer: {
        position: {
          lat: 0,
          lng: 0
        },
        icon: {
          url: require('@/assets/images/customer.png'),
          size: {
            width: 40,
            height: 40
          }
        },
        offset: {
          width: 0,
          height: -15
        },
        title: '您的位置',
        address: '',
        showInfo: true
      },
      ak_requestKey: [
        'B3f7707c25da5b29a6ff69618788a296',
        'PrhSE13yGgnGnWgeAuG39mr2SSiNMyEe',
        'jRhT1FYrcw2qUo89ftfV8itBViExLTgv'
      ]
    }
  },
  computed: {
    // 计算视口高度，用于指定地图组件渲染高度
    height() {
      return {
        height: `${window.innerHeight}px`
      }
    },
    engineerTitle() {
      return `${this.engineer.title}<br/> 距您还有${this.distance}(约${this.duration})`
    }
  },
  methods: {
    // 路线检索完成后触发事件，获取当前线路的时间
    // searchcomplete(result) {
    //   let planNum = result.getNumPlans()
    //   console.log(result)

    //   if (planNum) {
    //     for (let i = 0; i < planNum; i++) {
    //       this.distance = result.getPlan(i).getDistance()
    //     }
    //   }
    // },
    // 位置数据
    getlocation(lng, lat, zoom) {
      this.center.lng = lng
      this.center.lat = lat
      this.zoom = zoom
      this.loading = false // 数据准备加载完成后关闭遮罩层
    },
    // 返回上一页
    back() {
      this.$router.back()
    },
    // 地图需要的数据应该在此处进行赋值而非 vue 的声明周期中
    mapReady({ BMap, map }) {
      var startPoint, endPoint

      // 驾车规划
      var driving = new BMap.DrivingRoute(map, {
        renderOptions: { map: map, autoViewport: true }
      })
      // 公交规划
      var transit = new BMap.TransitRoute(map, {
        renderOptions: { map: map, autoViewport: true }
      })
      // 步行规划
      var walking = new BMap.WalkingRoute(map, {
        renderOptions: { map: map, autoViewport: true }
      })

      getToken(token => {
        // console.log(this.$route.query)
        this.$http
          .get(process.env.VUE_APP_API, {
            params: {
              type: 'get_location',
              so_no: this.$route.query.so_no,
              token
            }
          })
          .then(resp => {
            let data = resp.data
            if (resp.status === 200 && data.CODE === 'OK') {
              // 从数据接口获取数据并赋值【工程师】坐标
              this.engineer.position.lat = data.LOCATION.SO_LAT
              this.engineer.position.lng = data.LOCATION.SO_LNG
              // ---工程师的坐标---
              startPoint = new BMap.Point(
                data.LOCATION.SO_LNG,
                data.LOCATION.SO_LAT
              )
              console.log(
                '工程师的坐标经纬度----',
                data.LOCATION.SO_LAT,
                data.LOCATION.SO_LNG,
                '----------------'
              )
              console.log('工程师的坐标', startPoint)
              // console.log("地址1: ", data.LOCATION.ADDRESS)
              this.engineer.address = data.LOCATION.ADDRESS
              this.customer.address = data.LOCATION.CUST_ADDRESS
              console.log('客户地址', data.LOCATION.CUST_ADDRESS)
              if (
                this.engineer.position.lat == null ||
                this.engineer.position.lng == null
              ) {
                var self = this
                this.$Message.error({
                  content: '工程师地理位置出错',
                  duration: 3,
                  onClose() {
                    self.back()
                  }
                })
              }
              let ak_key = this.ak_requestKey[1] //! ---线上用1---  // 旧版ak地址 版本为v2  => ak_requestKey[0]
              // let ak_key = this.ak_requestKey[0] //! ---测试用0---   // 旧版ak地址 版本为v2  => ak_requestKey[0]
              // 通过地址获取坐标是以调用百度地图 API JSONP 的方式返回
              jsonp(
                `https://api.map.baidu.com/geocoding/v3/?address=${this.customer.address}&output=json&ak=${ak_key}&callback=renderReverse`,
                null,
                (err, data) => {
                  // console.log('data', data)
                  // 通过 map getViewPort 获取当前视图的的中心坐标与缩放比例, center是坐标位置
                  const { center, zoom } = map.getViewport([
                    this.engineer.position,
                    this.customer.position
                  ])
                  if (err) {
                    // 超时时  Error: Timeout
                    var self = this
                    this.$Message.error({
                      content: err,
                      duration: 3,
                      onClose() {
                        self.back()
                      }
                    })
                  } else if (data.status === 0) {
                    // 从数据接口获取数据并赋值【客户】坐标
                    this.customer.position.lat = data.result.location.lat
                    this.customer.position.lng = data.result.location.lng
                    // ---客户的坐标---
                    endPoint = new BMap.Point(
                      data.result.location.lng,
                      data.result.location.lat
                    )
                    var curDistance = (
                      map.getDistance(startPoint, endPoint) / 1000
                    ).toFixed(3) // 获取两点之间距离(精确到米)
                    console.log('当前两点之间直线距离', `${curDistance}公里`)
                    if (curDistance >= 45) {
                      console.log('推荐驾车')
                      driving.search(startPoint, endPoint)
                      driving.setSearchCompleteCallback(rs1 => {
                        driving.getResults().getPlan(0)
                        this.distance = driving
                          .getResults()
                          .getPlan(0)
                          .getDistance(true)
                        this.duration = driving
                          .getResults()
                          .getPlan(0)
                          .getDuration(true)
                        console.log(
                          '驾车',
                          this.distance,
                          '预估时间',
                          this.duration
                        )
                      })
                    } else if (curDistance < 45 && curDistance > 1) {
                      console.log('进入公交或步行的推荐范围')
                      transit.search(startPoint, endPoint)
                      transit.setSearchCompleteCallback(rs2 => {
                        // console.log('公交方案', transit.getResults().getPlan(0))---没有方案返回undefined
                        if (transit.getResults().getPlan(0)) {
                          console.log('推荐公交')
                          this.distance = transit
                            .getResults()
                            .getPlan(0)
                            .getDistance(true)
                          this.duration = transit
                            .getResults()
                            .getPlan(0)
                            .getDuration(true)
                          console.log(
                            '公交',
                            this.distance,
                            '预估时间',
                            this.duration
                          )
                        } else {
                          console.log('推荐步行')
                          walking.search(startPoint, endPoint)
                          walking.setSearchCompleteCallback(rs3 => {
                            this.distance = walking
                              .getResults()
                              .getPlan(0)
                              .getDistance(true)
                            this.duration = walking
                              .getResults()
                              .getPlan(0)
                              .getDuration(true)
                            console.log(
                              '步行',
                              this.distance,
                              '预估时间',
                              this.duration
                            )
                          })
                        }
                      })
                    } else {
                      console.log('只是步行')
                      walking.search(startPoint, endPoint)
                      walking.setSearchCompleteCallback(rs3 => {
                        this.distance = walking
                          .getResults()
                          .getPlan(0)
                          .getDistance(true)
                        this.duration = walking
                          .getResults()
                          .getPlan(0)
                          .getDuration(true)
                        console.log(
                          '步行',
                          this.distance,
                          '预估时间',
                          this.duration
                        )
                      })
                    }
                    this.getlocation(center.lng, center.lat, zoom)
                  } else if (data.status === 1 || data.status === 2) {
                    this.getlocation(center.lng, center.lat, zoom)
                  } else {
                    var that = this
                    this.$Message.error({
                      content: data.msg,
                      duration: 3,
                      onClose() {
                        that.back()
                      }
                    })
                  }
                }
              )
            }
          })
          .catch(err => {
            this.$Message.error({ content: err })
          })
      })
      // 占位
    }
  }
}
</script>

<style lang="scss" scoped>
.map-wrapper {
  width: 100%;

  .ivu-layout-header {
    font-size: 18px;
    font-weight: bold;
    box-shadow: 0 2px 4px 4px rgba(0, 0, 0, 0.2);
    padding: 0 10px;
    background: white;
    height: 50px;
    line-height: 50px;
    z-index: 1;

    .ivu-btn-text {
      &:focus {
        box-shadow: none;
      }
    }

    .ivu-btn-large {
      font-weight: bold;
      padding: 0;

      .ivu-icon {
        // font-weight: bold;
        font-size: 28px;
      }
    }
  }
}
</style>
